var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTransferTransavia(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "12px",
    height: "319px",
    viewBox: "0 0 12 319",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "80577EC4-D378-4716-8733-35611B2AAC80") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Transavia_Flightcards",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Transavia/Flightcards_MobileDates",
    transform: "translate(-486, -741)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Transavia/Flightcard/Mobile/Dates/Transfer/Selected-Copy",
    transform: "translate(470, 268)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "FlightConnector/Vertical/XLarge/Transfer",
    transform: "translate(16, 473)"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 6,
    y1: 125,
    x2: 6,
    y2: 199,
    id: "Line-Copy-2",
    stroke: "#8F8F8F",
    strokeWidth: 2,
    strokeDasharray: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 6,
    y1: 2,
    x2: 6,
    y2: 125,
    id: "Line",
    stroke: "#2800A0",
    strokeWidth: 2,
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy",
    fill: "#2800A0",
    cx: 6,
    cy: 6,
    r: 6
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#2800A0",
    cx: 6,
    cy: 125,
    r: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 6,
    y1: 196,
    x2: 6,
    y2: 313,
    id: "Line-Copy",
    stroke: "#2800A0",
    strokeWidth: 2,
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy-3",
    fill: "#2800A0",
    cx: 6,
    cy: 196,
    r: 5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy-2",
    fill: "#2800A0",
    cx: 6,
    cy: 313,
    r: 6
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTransferTransavia);
export default __webpack_public_path__ + "static/media/transfer-transavia.4255f5e0fc5165c6cf0ce82a40679931.svg";
export { ForwardRef as ReactComponent };